import React, { useContext } from 'react'
import PhoneInput from 'react-phone-number-input'
import { genericFieldLabelContainer } from '../../../genericControls/genericFieldLabelContainer'
import { FormItemContext } from '../FormItem'

const PhoneNumberInput = () => {

  // formItemContext
  const formItemContext = useContext(FormItemContext)
  const { formItem_state } = formItemContext ?? {}
  const { fip } = formItem_state ?? {}

  const { label, value, propname, onChange } = fip

  const _value = value ? value : ''

  const handleChange = (d) => {
    const data = { propname, value: d }
    onChange(null, data)
  }

  // return genericFieldLabelContainer('pni', label, <PhoneInput placeholder={label} defaultCountry="US" value={_value} onChange={handleChange} />)
  return <div className={'phone-container full'}>
    {genericFieldLabelContainer('pni', label, <PhoneInput placeholder={label} defaultCountry="US" value={_value} onChange={handleChange} />)}
  </div>
}
// }

export default PhoneNumberInput
